import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import React from "react";

function App()
{
    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route exact path="/" element={<Homepage />}></Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
